import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.less']
})
export class AdminHeaderComponent implements OnInit {

  constructor(
    private router:Router,
    private auth:AuthenticationService
  ) { }

  ngOnInit() {
  }
  logout(){
    this.auth.doLogout();
    this.router.navigate(['/admin-login']);
  }

}
